@if (data && data.telecom) {
  <p align="center" class="text-center text-bold">{{data.telecom}}  <i class="fa fa-copy cursor-pointer" title="Copy to clipboard" (click)="copyToClipboard(data.telecom)"></i></p>
}
